import { useEffect, useState } from "react";
import { Phone } from "lucide-react";

const links = [
  { href: "#services", label: "Services" },
  { href: "#gallery", label: "Gallery" },
  { href: "#about", label: "About" },
  { href: "#booking", label: "Book" },
  { href: "#contact", label: "Contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "glass border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3" data-testid="header-logo">
          <img
            src="/logo.png"
            alt="AB Details — Premium Detailing. Flawless Finish."
            className="h-10 w-10 sm:h-11 sm:w-11 object-contain"
          />
          <div className="leading-tight">
            <div className="font-display font-extrabold tracking-tight text-base sm:text-lg">
              AB Details
            </div>
            <div className="text-[10px] uppercase tracking-[0.22em] text-gold/80">
              Christchurch · NZ
            </div>
          </div>
        </a>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-sm text-neutral-300 hover:text-white transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a
            href="tel:02041721039"
            data-testid="header-call-btn"
            className="hidden sm:inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-neutral-300 hover:text-white"
          >
            <Phone className="w-3.5 h-3.5" strokeWidth={1.6} /> 020 4172 1039
          </a>
          <a
            href="#booking"
            data-testid="header-book-btn"
            className="inline-flex items-center gap-2 bg-white text-black hover:bg-neutral-200 px-4 py-2 text-xs font-semibold uppercase tracking-[0.16em] transition-colors"
          >
            Book Now
          </a>
        </div>
      </div>
    </header>
  );
}
